import React, { SetStateAction } from "react";
import { ITransactionCostFilters } from "./TransactionCost/TransactionCostIndex";
import { IBaseFilterBrokerRank } from "./BrokerRank/BrokerRankIndex";
import { ICounterpartyReportFilters } from "./CounterpartyReport/CounterpartyReportIndex";

interface ISelectAllAnalyticsFilters<
  T extends
    | ITransactionCostFilters
    | IBaseFilterBrokerRank
    | ICounterpartyReportFilters,
> {
  dataFilters: T;
  setDataFilters: React.Dispatch<SetStateAction<T>>;
  dataFilterField: keyof T;
  keysToMap: Record<string, string[]>;
  keysToMapField: string;
}

const SelectAllCheckBox = <
  T extends
    | ITransactionCostFilters
    | IBaseFilterBrokerRank
    | ICounterpartyReportFilters,
>({
  dataFilters,
  setDataFilters,
  dataFilterField,
  keysToMap,
  keysToMapField,
}: ISelectAllAnalyticsFilters<T>) => {
  function allChecked(keys: string[]) {
    if (dataFilterField in dataFilters) {
      const currentState =
        dataFilters[dataFilterField as keyof typeof dataFilters];

      if (Array.isArray(currentState) && currentState.length === keys.length) {
        // Use type assertion to match the actual type
        setDataFilters({
          ...dataFilters,
          [dataFilterField]: [],
        });
      } else {
        setDataFilters({
          ...dataFilters,
          [dataFilterField]: [...keys],
        });
      }
    }
  }

  function checkedValue(): boolean {
    if (dataFilterField in dataFilters) {
      const currentState =
        dataFilters[dataFilterField as keyof typeof dataFilters];

      const mapsValue = keysToMap[keysToMapField];

      const isEqual =
        Array.isArray(currentState) && currentState.length === mapsValue.length;
      return isEqual;
    }
    return false;
  }

  return (
    <div className="pb-2 text-xs">
      <input
        type="checkbox"
        className=" accent-blue-500"
        checked={checkedValue()}
        onChange={() => allChecked(keysToMap[keysToMapField])}
      />
      <span className="pl-1">ALL:</span>
    </div>
  );
};

export default SelectAllCheckBox;
